import api from "../api";
import { IEtiquetaUsuario } from "../interfaces/editor/etiquetaUsuario";

const API_BASE = "/api/UsuarioEtiquetas";

const getEtiqueta = async function (id: number) {
  return api.get(`${API_BASE}/${id}`);
};

const listEtiquetasUsuario = async function () {
  return api.get(`${API_BASE}`);
};

const saveEtiqueta = async function (userData: { [key: string]: string }) {
  return api.post(`${API_BASE}`, userData);
};

const updateEtiqueta = async function (etiqueta: IEtiquetaUsuario) {
  return api.put(`${API_BASE}/${etiqueta.idUsuarioEtiqueta}`, etiqueta);
};

const deleteEtiqueta = async function (id: number) {
  return api.delete(`${API_BASE}/${id}`);
};

const etiquetasUsuarioService = {
  getEtiqueta,
  listEtiquetasUsuario,
  saveEtiqueta,
  updateEtiqueta,
  deleteEtiqueta,
};

export default etiquetasUsuarioService;
